// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"a33b1a4f","702":"3c63ccfd","796":"3d3341d0","809":"1e61c94e","911":"c85d4236","987":"28e525c5"}[chunkId] + ".chunk.css";
};